import React from 'react';
import { ServiceRuleCell } from '../../../inventory/services/service-rule-cell';
import { InfoMessage } from '../../../../shared/info-message/info-message';

type InfoServiceMsgProps = {
    service: any;
}

export const InfoServiceMsg: React.FC<InfoServiceMsgProps> = ({service}) => {
    return (
        <InfoMessage
            header="Any changes to this service will apply on all its associated rules:"
            contentComponent={ServiceRuleCell}
            contentProps={{ serviceData: service.data }}
        />
    );
};


